<template>
  <div class="index-page">
    <img src="https://arbon2022-sh.oss-cn-shanghai.aliyuncs.com/cne/page2_1.png">
    <img src="https://arbon2022-sh.oss-cn-shanghai.aliyuncs.com/cne/page2_2.png">
    <img src="https://arbon2022-sh.oss-cn-shanghai.aliyuncs.com/cne/page2_3.png">
    <img src="https://arbon2022-sh.oss-cn-shanghai.aliyuncs.com/cne/page2_4.png">
    <div class="fixed-bottom" @click="openWeapp()">
      <button>
        <p>立即预登记</p>
        <span>REGISTER NOW</span>
      </button>
    </div>
  </div>
</template>

<script>

import axios from "axios";
import data from "../util/data"

export default {
  name: "invitation",
  data(){
    return{
      exhibitId:"",
      exhibitorId:"",
      tenantId:"",
      openlink:"",
    }
  },
  created() {
    this.exhibitId = this.getUrlKey("exhibitId");
    this.exhibitorId = this.getUrlKey("exhibitorId");
    this.tenantId = this.getUrlKey("tenantId");
    this.getWechatConfig();
    this.generatescheme();
  },
  methods:{
    /***
     * 获取url中的参数
     * @param name
     * @returns {string | null}
     */
    getUrlKey(name) {
      let r = new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""];
      return decodeURIComponent(r[1].replace(/\+/g, '%20')) || null;
    },
    onLoaded(v) {
      this.username = v.jwId;
      wx.config({
        debug: false, // 调试时可开启
        appId: v.appid, // 必填，公众号的唯一标识
        timestamp: v.timestamp, // 必填，生成签名的时间戳
        nonceStr: v.nonceStr, // 必填，生成签名的随机串
        signature: v.signature,// 必填，签名，见附录1
        jsApiList: ["updateAppMessageShareData", "updateTimelineShareData","onMenuShareTimeline","onMenuShareAppMessage"],
        openTagList: ['wx-open-launch-weapp'], // 填入打开小程序的开放标签名
      })
      let _self = this;
      wx.ready(function () {

        let shareContent = {
          title: '诚邀参观  \r\n上海国际碳中和博览会', // 分享标题
          link: window.location.href,
          desc: "2023.6.11-14 \r\n国家会展中心（上海）" ,
          imgUrl: "https://arbon2022-sh.oss-cn-shanghai.aliyuncs.com/cne/cne-logo3.jpg"
        }
        wx.updateTimelineShareData(shareContent);

        wx.updateAppMessageShareData(shareContent)

      });
      wx.error(function (res) {
        console.log('res', res);
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      });
    },
    getWechatConfig() {
      let that = this;
      axios.post( data.getWechatConfig, {
        url: window.location.href.split('#')[0],
        exhibitId: this.exhibitId
      },{
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      }).then(res => {
        if (res.data.code == 200) {

          that.onLoaded(res.data.data);
        }
      })
    },
    generatescheme() {
      axios.post( data.generatescheme, {
        exhibitId: this.exhibitId,
        exhibitorId: this.exhibitorId,
        domainType: 2
      }).then(res => {
        if(res.data.code==200){

          this.openlink=res.data.data.openlink
        }
      })
    },
    async openWeapp(onBeforeJump) {
      if (onBeforeJump) {
        onBeforeJump()
      }
      if (this.openlink != null) {
        location.href = this.openlink
      }

    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/invitation.vue